import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { PrimaryButton, SectionTag } from "@/components/ui-bits";
import api from "@/lib/api";

const InsightDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/insights/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="flex min-h-screen items-center justify-center font-mono text-sm text-tark-dim">Loading…</div>;
  if (!post) return <Navigate to="/insights" replace />;

  return (
    <article className="relative overflow-hidden pt-40 pb-28" data-testid="insight-article">
      <div className="absolute inset-0 spotlight" />
      <div className="relative mx-auto max-w-3xl px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <Link to="/insights" data-testid="insight-back" className="inline-flex items-center gap-2 font-mono text-xs text-tark-dim transition-colors hover:text-tark-cyan">
            <ArrowLeft className="h-3.5 w-3.5" /> All Insights
          </Link>
          <div className="mt-8">
            <SectionTag>{post.tag}</SectionTag>
          </div>
          <h1 className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            {post.title}
          </h1>
          {post.excerpt && <p className="mt-6 text-base leading-relaxed text-tark-mut sm:text-lg">{post.excerpt}</p>}
          <div className="mt-10 h-px w-full bg-gradient-to-r from-tark-blue via-tark-line to-transparent" />
          <div className="mt-10 space-y-6">
            {post.content?.split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-base leading-relaxed text-tark-mut">{para}</p>
            ))}
          </div>
          <div className="mt-16 rounded-2xl border border-tark-blue/40 bg-gradient-to-br from-tark-card to-[#0A1A33] p-8">
            <h2 className="font-display text-xl font-bold">Building something similar?</h2>
            <p className="mt-2 text-sm text-tark-mut">Talk to a TARK engineering lead about your platform.</p>
            <div className="mt-6">
              <PrimaryButton to="/start-a-project" testId="insight-cta">Talk to an Expert</PrimaryButton>
            </div>
          </div>
        </motion.div>
      </div>
    </article>
  );
};

export default InsightDetail;
